import { Directive, ElementRef, Input, Renderer2, AfterViewInit, OnDestroy } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';

@Directive({
	selector: '[kvvideo]'
})
export class KvVideoDirective implements AfterViewInit, OnDestroy {
	@Input() clipScope!: any;

	private loadedMetadataListener: any;

	constructor(private el: ElementRef, private renderer: Renderer2) { }

	ngAfterViewInit() {
		this.loadedMetadataListener = this.renderer.listen(this.el.nativeElement, 'loadedmetadata', (event: Event) => {
			const target = event.target as HTMLVideoElement;
			const duration = Math.floor(target.duration);
			setTimeout(() => {
				if (this.clipScope) {
					this.clipScope.videoDuration = duration;
					this.clipScope.end = duration;
				}
			}, 100);
		});
	}

	ngOnDestroy() {
		if (this.loadedMetadataListener) {
			this.loadedMetadataListener();
		}
	}
}